import * as types from "./gameUserProfile.constant";

const defaultState = {
    formData: {
        name:"",
        logo:3,
    },
    user:null,
    prizes:null,
    error:null
};

export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.GAME_USER_PROFILE_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };
        case types.GAME_USER_PROFILE_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
